import { ServiceRequestInterface } from "@nts/std/interfaces";

export class ServiceRequest implements ServiceRequestInterface {


}
